module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="signup-form-step">\n\n  <div class="form-group">\n    <label for="login-handle">Email address</label>\n    <input type="text"\n      id="login-handle"\n      value="' +
__e( handle ) +
'"\n      class="fs-hide"\n      autocorrect="off" />\n  </div>\n\n  <div class="form-group">\n    <label for="login-password">Password</label>\n    <input type="password"\n      id="login-password"\n      class="fs-hide"\n      autocorrect="off" />\n  </div>\n  <span id="login-error" class="help-block" style="display: none"></span>\n</div>\n';

}
return __p
}